import { constants } from '../../../constants';
import { MarkdownViewer } from './';

export const renderMarkdownOrEmpty = (content?: string | null) =>
    content ? <MarkdownViewer value={content} /> : constants.emptyPlaceholder;
